module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("There were dozens of photographs and wreaths to indicate the position on the coral-pink steps of his Miami Beach house where fashion legend Gianni Versace met his untimely death. His blood stains and police chalk marks where the bullet cases fell remained untouched for some hours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As crowds formed outside the mansion to mourn their slain idol, one man ripped Versace ads from a magazine and daubed them in the designer’s blood, as a keepsake.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Among the heartbroken fans there was a young dark-haired man in his mid-twenties watching avidly. He seemed to be smiling. Why?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Perhaps it was because the death of Gianni Versace had done more than shock the world—it had catapulted that man, Andrew Phillip Cunanan, into the history books as one of the most dangerous killers of the twentieth century.…")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08bb4edd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/reader1.vue
// module id = 69
// module chunks = 0